import type { FaireProductEntity } from "../../entity_types/product";

export const p_bh242x6cht: FaireProductEntity = {
  token: "p_bh242x6cht",
  type: "product",
  name: "Arkansas Razorbacks Embroidered Red Gingham Ruffle Dress",
  brandToken: "b_8jehdemzqt",
  brandName: "Vive La Fete",
  imageUrl:
    "https://cdn.faire.com/fastly/7241756e26b18fd6719d4ffb8409d39799967f83a105fd6e1c03bc4cee0c3a95.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9e4600608a2a7b8901fc82b2178ff9c6fa1061bfeda9f025c7d27ac64e8b5037.jpeg",
  ],
  priceDollars: 24.99,
  description: "Arkansas Razorbacks Embroidered Red Gingham Ruffle Dress",
  tags: [],
  msrpDollars: 44.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:31.336Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
